<script lang="ts" generics="TValues, TValue">
    import type { Field, Form } from '@jmvdevelop/svelte-form';
    import PrettyMultiChoice, {
        type Choice,
    } from '$components/Form/PrettyMultiChoice.svelte';
    import ModalMobile from '$components/Form/ModalMobile/ModalMobile.svelte';
    import RowInModal from '$components/Form/ModalMobile/RowInModal.svelte';
    import DialogFragment from '$components/MeltUtils/DialogFragment.svelte';
    import { melt } from '@melt-ui/svelte';
    import ScrollView from '$components/ScrollView/ScrollView.svelte';

    export let form: Form<TValues, string>;
    export let field: Field<TValues, TValue[]>;
    export let label: string;
    export let description: string | null = null;
    export let required: boolean = false;
    export let id: string | null = null;
    export let prefixId: string | undefined = undefined;
    export let modalTitle: string | null = null;
    export let choices: readonly Choice<TValue>[];
    export let areEqual: (a: TValue, b: TValue) => boolean = (a, b) => a === b;

    function getLabel(value: TValue) {
        const c = choices.find((c) => areEqual(c.value, value));
        return c?.label ?? '';
    }

    $: values = form.stores().fieldValue(field);
    $: effectiveDescription =
        $values.length === 0
            ? (description ?? '')
            : $values
                  .map((value) => {
                      return getLabel(value);
                  })
                  .join(', ');
</script>

<RowInModal
    {form}
    {field}
    {label}
    {required}
    {prefixId}
    description={effectiveDescription}
    {id}
    let:form
    let:field
    let:label
    let:dialog
    let:id
>
    <ModalMobile
        {dialog}
        title={modalTitle ?? label}
        closeIcon="chevron"
        transitionStyle="push"
    >
        <ScrollView class="flex-1">
            <div class="px-[20px] py-[14px]">
                <PrettyMultiChoice
                    class="b:grid-cols-1 b:gap-0"
                    {form}
                    {field}
                    {choices}
                    {id}
                    {areEqual}
                />
            </div>
        </ScrollView>

        <svelte:fragment slot="footer">
            <DialogFragment {dialog} let:closeEl>
                <button
                    type="button"
                    class="btn-leo btn-leo-primary btn-xl w-full"
                    use:melt={closeEl}
                    >Valider
                </button>
            </DialogFragment>
        </svelte:fragment>
    </ModalMobile>
</RowInModal>
